export const initialFormState = {
  asset: '',
  booking_wanted_date: '',
  booking_wanted_time: '',
  availability_months: '',
  household_type: '',
  household_adults: '',
  household_children: '',
  step: '',
  status: '',
  lead: {
    first_name: '',
    last_name: '',
    phone_number: '',
    email: '',
  },
  applicants: [
    {
      reference: 'lead',
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      french_resident: false,
      social_security_number: '',
      situation: '',
      probation: false,
      revenue: '',
      revenue_reference: '',
      guarantor_type: '',
      guarantor_situation: '',
      guarantor_revenue: '',
      guarantor_revenue_reference: '',
      lead: true,
      duration: '',
      guarantor_duration: '',
    },
  ],
}
